import { JSX } from 'react'

import { IconProps } from '../../icon'

const Google: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 60}
    id={id}
    stroke={stroke}
    viewBox='0 0 32 32'
    width={width || 65}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_4169_16370)'>
      <path
        d='M17.6418 0.35907C16.1796 0.460212 14.4704 1.39621 13.4744 2.61506C12.5659 3.72076 11.8185 5.36304 12.1099 6.95903C13.7076 7.00875 15.3584 6.05047 16.315 4.81104C17.2099 3.65734 17.887 2.02535 17.6418 0.35907Z'
        fill='black'
      />
      <path
        d='M23.4203 9.56132C22.0163 7.80076 20.0432 6.77905 18.1798 6.77905C15.7198 6.77905 14.6792 7.95676 12.9701 7.95676C11.2078 7.95676 9.86895 6.78248 7.74153 6.78248C5.65183 6.78248 3.4267 8.05962 2.01585 10.2436C0.0324349 13.319 0.371861 19.1013 3.58613 24.0264C4.73641 25.7887 6.2724 27.7704 8.28153 27.7875C10.0695 27.8046 10.5735 26.6407 12.9958 26.6287C15.4181 26.6149 15.8775 27.8029 17.662 27.7841C19.6729 27.7686 21.2929 25.5727 22.4432 23.8104C23.2677 22.547 23.5746 21.911 24.214 20.4847C19.5632 18.7138 18.8175 12.1002 23.4203 9.56132Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_4169_16370'>
        <rect
          width='24'
          height='27.4286'
          fill='white'
          transform='translate(0.5 0.35907)'
        />
      </clipPath>
    </defs>
  </svg>
)
export default Google
